import type { FC } from "react"

import { motion } from "framer-motion"
import styled from "styled-components"

import Spinner from "~/components/Spinner"

export const Header = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  border-bottom: 1px solid #dddddd;
  align-items: center;
  justify-content: space-between;
  padding-bottom: var(--space-xs);
  svg {
    cursor: pointer;
    width: 25px;
    height: 25px;
  }
  h1 {
    color: #333333;
  }
`
export const StyledWrapper = styled(motion.div)`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  gap: var(--space-s);
  position: absolute;
  background-color: white;
  left: 0;
  bottom: calc(100% + var(--space-xs));
  border-radius: 7px;
  padding: var(--space-s);
  textarea {
    width: 100%;
    height: 200px;
    border: none;
    border: 1px solid #dddddd;
    resize: none;
    border-radius: 7px;
    padding: var(--space-s);
    font-size: var(--step--1);
  }
`

export const Wrapper: FC<{
  children: React.ReactNode
  isSaving?: boolean
}> = ({ children, isSaving }) => {
  return (
    <StyledWrapper
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      {isSaving && <Spinner color="var(--blue)" size={60} />}
      {!isSaving && children}
    </StyledWrapper>
  )
}

export const Info = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 30px;
  p {
    font-size: var(--step--2);
    color: #93a8c3;
  }
`

export const CharsLeft = styled.p`
  white-space: nowrap;
`

export const Buttons = styled.div`
  display: flex;
  gap: var(--space-xs);
  > button {
    font-size: var(--step--2);
    cursor: pointer;
    :first-of-type {
      background-color: var(--blue);
      color: white;
      text-transform: capitalize;
      border-radius: 7px;
      width: fit-content;
      height: 45px;
      padding: 0 var(--space-m);
    }
  }
  > button:disabled {
    background-color: var(--blue-faded);
    cursor: not-allowed;
  }
`
